import { User } from '@/types/user'
import { Mutation } from 'vuex'
import { UserState } from '../types'

const setUserState: Mutation<UserState> = (state, user: User) => {
  state.current = Object.freeze(user)
  state.disableSoundNotifications = user.disable_sound_notifications ?? false
}

export default setUserState
